import { NotificationType } from '../types';

export interface NotificationMeta {
  label: string;
  /** Tailwind background class for the toast accent bar. */
  bar: string;
  /** Tailwind text class for the small channel label. */
  text: string;
  /** Short glyph used in dense lists. */
  glyph: string;
}

/**
 * One source of truth for notification labels/colours. Previously the toast and
 * the dashboard feed each had their own binary APPLICATION/MISSION styling,
 * which made every new channel look like "Aerial Intelligence".
 */
export const NOTIFICATION_META: Record<NotificationType, NotificationMeta> = {
  APPLICATION: { label: 'Job Applicant', bar: 'bg-[#5FA136]', text: 'text-[#7BC24C]', glyph: '👤' },
  MISSION: { label: 'Aerial Intelligence', bar: 'bg-orange-500', text: 'text-orange-400', glyph: '🛰️' },
  SYSTEM: { label: 'System', bar: 'bg-stone-500', text: 'text-stone-300', glyph: '⚙️' },
  APPOINTMENT: { label: 'Appointment', bar: 'bg-blue-500', text: 'text-blue-300', glyph: '📅' },
  ESTIMATE: { label: 'Estimate Request', bar: 'bg-amber-500', text: 'text-amber-300', glyph: '📝' },
  ACCOUNT: { label: 'New Account', bar: 'bg-violet-500', text: 'text-violet-300', glyph: '👥' },
  ACTIVITY: { label: 'Site Activity', bar: 'bg-teal-500', text: 'text-teal-300', glyph: '🌐' },
};

export function notificationMeta(type: NotificationType | string): NotificationMeta {
  return (NOTIFICATION_META as Record<string, NotificationMeta>)[type] || NOTIFICATION_META.SYSTEM;
}
